// extracted by mini-css-extract-plugin
export default {"mainSection":"MyProfile_mainSection__Ab2qE","sectionTitle":"MyProfile_sectionTitle__iuqab"};